import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
//import Markdown from 'react-remarkable';
import { Remarkable } from 'remarkable';
import RemarkableReactRenderer from 'remarkable-react';

import './Education.css';

/**
* @desc Education tab content in candidate profile section
* @param props
* @return DOMElement
*/
const Education = (props) => {
  let startDateEducationStr = (props.dateStart && props.dateStart !== '' && props.dateStart !== "0000-00-00 00:00:00") ? moment(props.dateStart).format("MMM YYYY") : '';
  let endDateEducationStr = (props.dateEnd && props.dateEnd !== '' && props.dateEnd !== "0000-00-00 00:00:00") ? ' - ' + moment(props.dateEnd).format("MMM YYYY") : '';

  if(startDateEducationStr === "" && endDateEducationStr === "") {
    startDateEducationStr = "Not Specified";
  }

  const md = new Remarkable();
  md.set({
    html: true,
    breaks: true
  });
  md.block.ruler.disable([ 'code']);
  md.renderer = new RemarkableReactRenderer();

  return (
    (props.accreditation && props.accreditation !== "") ?
      <div className="candidate-education tab-body">
        <Row className="timeline">
          <Col  sm={4} className="date-cont">
            <div className="date">{startDateEducationStr} {endDateEducationStr}</div>
          </Col>
          <Col sm={8} className="education">
            <div className="ed-degree">{props.accreditation}</div>
            <div className="ed-institution">{props.institution} {props.location}</div>
            <div className="ed-award">{props.award}</div>
            <div className="ed-description">{md.render(props.description)}</div>
            <div className="ed-line"></div>
          </Col>
        </Row>
      </div>
    : null
  );
}

export default Education;


// WEBPACK FOOTER //
// ./src/components/Client/Education/Education.js